/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamTokenResponse } from './oralExamTokenResponse';

export type GenericApiResponseOralExamTokenResponseData = OralExamTokenResponse | null;
